import axios from 'axios'
const postRequest = async (route, data, headerData) => {
  const post = await axios.post(`${process.env.REACT_APP_API_URL + route}`,
  data,
  {headers:headerData}
  )
  return post
}

export default postRequest;
